import { render } from "./CashPaymentModal.vue?vue&type=template&id=0b0823c8"
import script from "./CashPaymentModal.vue?vue&type=script&lang=js"
export * from "./CashPaymentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__